import TopicStatus from "@/constants/TopicStatus";

class TopicPermissions {
	constructor( { topic, userProfile, timezone, meetingPermissions = null, } ) {
		this.userProfile = userProfile;
		this.timezone = timezone;
		this.topic = topic;
		if ( meetingPermissions.resolve ) {
			meetingPermissions = meetingPermissions.resolve();
		}
		this.meetingPermissions = meetingPermissions;
	}

	_isNew() {
		return this.topic.id === "";
	}

	_isUserCreator() {
		const { userProfile, topic, } = this;
		const { creator = { personId: "", }, } = topic;
		return creator.personId === userProfile.personId;
	}

	canUserDefer() {
		if ( this._isNew() ) {
			return false;
		}
		const { topic, meetingPermissions, } = this;
		if ( !meetingPermissions ) {
			return this._isUserCreator();
		}
		const isPlannedTopic = topic.id && topic.status.toUpperCase() === TopicStatus.PLANNED;
		return !!( meetingPermissions.canUserDeferTopics && isPlannedTopic );
	}

	canUserUndefer() {
		if ( this._isNew() ) {
			return false;
		}
		const { topic, meetingPermissions, } = this;
		if ( !meetingPermissions ) {
			return this._isUserCreator();
		}
		const isDeferredTopic = topic.id && topic.status.toUpperCase() === TopicStatus.DEFERRED;
		return !!( meetingPermissions.canUserUndeferTopics && isDeferredTopic );
	}

	canUserRemove() {
		if ( this._isNew() ) {
			return false;
		}
		const { topic, meetingPermissions, } = this;
		if ( !meetingPermissions ) {
			return this._isUserCreator();
		}
		const isUserOrganizer = meetingPermissions.canUserRemoveTopics;
		const isPlannedTopic = topic.id && topic.status.toUpperCase() === TopicStatus.PLANNED;
		return !!( ( isUserOrganizer || this._isUserCreator() ) && isPlannedTopic );
	}

	canUserEdit() {
		const { meetingPermissions, } = this;
		if ( !meetingPermissions ) {
			return this._isUserCreator();
		}
		return meetingPermissions.canUserEditTopics || this._isUserCreator();
	}

	resolve() {
		const { topic, userProfile, } = this;
		return {
			topicId: topic.id,
			userId: userProfile.personId,
			canUserDefer: this.canUserDefer(),
			canUserUndefer: this.canUserUndefer(),
			canUserRemove: this.canUserRemove(),
			canUserEdit: this.canUserEdit(),
			// TODO: implementation
			canUserAdvanceTopic: true,
		};
	}
}

export default TopicPermissions;



// WEBPACK FOOTER //
// ./src/permissions/TopicPermissions.js